<span class="icon-addon">
    <i class="ti ti-calendar"></i>
</span>
<input type="text" class="form-control date-range bookingrange" placeholder="Select" value="Academic Year : 2024 / 2025"
    bsDaterangepicker [(ngModel)]="bsRangeValue" [bsConfig]="{ adaptivePosition: true }">